/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SoftwareEnvironmentAliasSchema } from './SoftwareEnvironmentAliasSchema';
import {
    SoftwareEnvironmentAliasSchemaFromJSON,
    SoftwareEnvironmentAliasSchemaFromJSONTyped,
    SoftwareEnvironmentAliasSchemaToJSON,
} from './SoftwareEnvironmentAliasSchema';

/**
 * 
 * @export
 * @interface PagedSoftwareEnvironmentAliasSchema
 */
export interface PagedSoftwareEnvironmentAliasSchema {
    /**
     * 
     * @type {Array<SoftwareEnvironmentAliasSchema>}
     * @memberof PagedSoftwareEnvironmentAliasSchema
     */
    items: Array<SoftwareEnvironmentAliasSchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedSoftwareEnvironmentAliasSchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedSoftwareEnvironmentAliasSchema interface.
 */
export function instanceOfPagedSoftwareEnvironmentAliasSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedSoftwareEnvironmentAliasSchemaFromJSON(json: any): PagedSoftwareEnvironmentAliasSchema {
    return PagedSoftwareEnvironmentAliasSchemaFromJSONTyped(json, false);
}

export function PagedSoftwareEnvironmentAliasSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedSoftwareEnvironmentAliasSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SoftwareEnvironmentAliasSchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedSoftwareEnvironmentAliasSchemaToJSON(value?: PagedSoftwareEnvironmentAliasSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(SoftwareEnvironmentAliasSchemaToJSON)),
        'count': value.count,
    };
}

